import React from 'react';
import { motion } from 'framer-motion';
export function ProofSection() {
  return <section className="py-16 px-6 bg-gradient-to-b from-blush-light to-cream relative" data-id="element-137">
      <div className="max-w-4xl mx-auto text-center" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="relative" data-id="element-139">
          <div className="absolute -top-10 left-1/2 -translate-x-1/2 text-gold opacity-20 text-9xl font-playfair leading-none" data-id="element-140">
            "
          </div>

          <h2 className="text-2xl md:text-3xl lg:text-4xl font-cormorant italic text-burgundy-deep leading-relaxed relative z-10 text-balance" data-id="element-141">
            En solo 21 días, tu línea base de estrés desciende lo suficiente
            para que el "Deseo Responsivo" emerja.
            <br data-id="element-142" />
            <br data-id="element-143" />
            Pasarás de apretar la mandíbula cuando te tocan, a buscar
            activamente el roce de tu propia piel y la de tu pareja porque tu
            cuerpo vuelve a ser un lugar seguro para el placer.
          </h2>

          <div className="mt-12 w-16 h-[1px] bg-gold mx-auto" data-id="element-144" />
        </motion.div>
      </div>
    </section>;
}